/**
 *
 * @param {UrlManager} urlManager
 * @param {RowSelection} selection
 */
export function linkUrlSelection(urlManager, selection){
    urlManager.onIdChange.subscribe(selection.set)
    selection.onRowSelected.subscribe(urlManager.rowSelected)
}